import { render, staticRenderFns } from "./DropdownArrow.vue?vue&type=template&id=dfc49f62&scoped=true&"
import script from "./DropdownArrow.vue?vue&type=script&lang=js&"
export * from "./DropdownArrow.vue?vue&type=script&lang=js&"
import style0 from "./DropdownArrow.vue?vue&type=style&index=0&id=dfc49f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc49f62",
  null
  
)

export default component.exports